<template>
    <kiosk-team-details :teamId="props.teamId" data-test="kiosk-team-details">
        <div
            class="col-span-12 lg:col-span-10 flex flex-col w-full max-w-(--breakpoint-sm) justify-center"
            data-test="plan-information-wrapper"
        >
            <team-plan-information
                :team="team"
                :team-plan="props.teamPlan"
                :team-message-balance="props.teamMessageBalance"
                :team-sum-balance-amount="props.teamSumBalanceAmount"
                :is-admin-or-owner="true"
            />
        </div>
    </kiosk-team-details>
</template>

<script setup>
import KioskTeamDetails from '~/components/kiosk/kiosk-teams/details/KioskTeamDetails.vue';
import { useTeamDetails } from '~/components/kiosk/kiosk-teams/composables/useTeamDetails';
import TeamPlanInformation from '~/components/settings/billing/TeamPlanInformation.vue';

const { team } = useTeamDetails();

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    teamPlan: {
        type: Object,
        required: true,
    },
    teamMessageBalance: {
        type: Number,
        required: true,
    },
    teamSumBalanceAmount: {
        type: Number,
        required: true,
    },
});
</script>
